/**
 * Defines how spacing should be applied to the children of a container.
 */
export var Spacing;
(function (Spacing) {
    Spacing[Spacing["condensed"] = 0] = "condensed";
    Spacing[Spacing["default"] = 1] = "default";
    Spacing[Spacing["relaxed"] = 2] = "relaxed";
})(Spacing || (Spacing = {}));
export var SurfaceBackground;
(function (SurfaceBackground) {
    SurfaceBackground[SurfaceBackground["normal"] = 0] = "normal";
    SurfaceBackground[SurfaceBackground["neutral"] = 1] = "neutral";
    SurfaceBackground[SurfaceBackground["callout"] = 2] = "callout";
})(SurfaceBackground || (SurfaceBackground = {}));
